// extracted by mini-css-extract-plugin
module.exports = {"second_column":"styles_second_column__1s6OP"};